// src/pages/BusinessPlan.jsx
import React from "react";
import { FaDownload } from "react-icons/fa";

const BusinessPlan = () => {
  const pdfUrl = "/pdf/pdf.pdf";

  return (
    <div className="min-h-screen bg-gray-100 flex justify-center px-3 py-4">

      {/* Card */}
      <div className="w-full max-w-4xl bg-white rounded-xl shadow-xl flex flex-col">

        {/* Header */}
        <div className="flex justify-between items-center px-4 py-3 border-b">
          <h2 className="text-base font-semibold text-gray-800">
            Business Plan
          </h2>

          <a
            href={pdfUrl}
            download
            className="flex items-center gap-2 bg-red-600 text-white px-3 py-1.5 rounded-md text-sm"
          >
            <FaDownload />
            Download
          </a>
        </div>

        {/* PDF Scroll Area */}
        <div className="flex-1 h-[75vh] overflow-y-auto overscroll-contain touch-pan-y">
          <iframe
            src={pdfUrl}
            title="Business Plan PDF"
            className="w-full h-full"
          />
        </div>

      </div>
    </div>
  );
};

export default BusinessPlan;
